import React, { Fragment, useEffect, useState } from 'react';
import {
  Button,
  Col,
  Container,
  Input,
  Label,
  Row,
} from 'reactstrap';

import ReactLoading from 'react-loading';
import axios from 'axios';
import { azaStageazaPath } from '../../utilities/UrlPaths';

const RequestLink = () => {
  const [houseValue, setHouseValue] = useState('');
  const [userValue, setUserValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [showErrorMessageH, setShowErrorMessageH] = useState(false);
  const [showErrorMessageU, setShowErrorMessageU] = useState(false);
  const [showErrorMessageE, setShowErrorMessageE] = useState(false);
  const [houseError, setHouseError] = useState('');
  const [userError, setUserError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showCheckEmail, setShowCheckEmail] = useState(false);

  useEffect(() => {
    const clearError = () => {
      if (houseValue) setShowErrorMessageH(false);
      if (userValue) setShowErrorMessageU(false);
      if (emailValue) setShowErrorMessageE(false);
    };
    clearError();
  }, [houseValue, userValue, emailValue]);

  const sendResetLink = async () => {
    if (houseValue && userValue && emailValue) {
      const apiUrl = `${azaStageazaPath()}/house/user/forgotPassword`;
      const hostnameArray = window.location.hostname.split('.');
      const domain = hostnameArray[1];
      const postBody = {
        houseUserName: houseValue,
        userName: userValue,
        emailAddress: emailValue,
        domain,
      };

      try {
        setLoading(true);
        await axios.post(apiUrl, postBody, { headers: { 'Content-Type': 'application/json' } });
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
      setShowCheckEmail(true);
    } else {
      if (!houseValue) {
        setHouseError('error-border');
        setShowErrorMessageH(true);
      }
      if (!userValue) {
        setUserError('error-border');
        setShowErrorMessageU(true);
      }
      if (!emailValue) {
        setEmailError('error-border');
        setShowErrorMessageE(true);
      }
    }
  };

  if (loading) {
    return <ReactLoading className="loading-spinner" type="spin" color="black" />;
  }
  return (
    <Container className="mt-4 pt-2 pb-5">
      <Row>
        <Col xs={12} md={8} lg={6}>
          <h1>Request reset password link</h1>
          {showCheckEmail
          && (
          <div>
            Check <span className="font-weight-bold">{emailValue}</span> to find your password reset instructions.  If you do not receive an email, contact Customer Care.
          </div>
          )}
          {!showCheckEmail
            && (
              <Fragment>
                <div className="mt-4">
                  <Label htmlFor="houseID" className="font-weight-bold">House ID*</Label>
                  <Input
                    type="text"
                    className={`form-control ${houseError}`}
                    name="houseID"
                    title="House ID"
                    value={houseValue}
                    onChange={e => setHouseValue(e.target.value)}
                    onFocus={() => setHouseError('')}
                  />
                  {showErrorMessageH
                  && (
                  <div className="password-error">
                    House Name is a required field
                  </div>
                  )}
                </div>
                <div className="mt-3">
                  <Label htmlFor="username" className="font-weight-bold">Username*</Label>
                  <Input
                    type="text"
                    className={`form-control ${userError}`}
                    name="username"
                    title="Username"
                    value={userValue}
                    onChange={e => setUserValue(e.target.value)}
                    onFocus={() => setUserError('')}
                  />
                  {showErrorMessageU
                  && (
                  <div className="password-error">
                    Username is a required field
                  </div>
                  )}
                </div>
                <div className="mt-3">
                  <Label htmlFor="email" className="font-weight-bold">Email*</Label>
                  <Input
                    type="text"
                    className={`form-control ${emailError}`}
                    name="email"
                    title="Email"
                    value={emailValue}
                    onChange={e => setEmailValue(e.target.value)}
                    onFocus={() => setEmailError('')}
                  />
                  {showErrorMessageE
                  && (
                  <div className="password-error">
                    Email is a required field
                  </div>
                  )}
                </div>
                <div className="mt-4">
                  <Button
                    onClick={() => sendResetLink()}
                    className="w-50"
                    color="primary"
                  >
                    Request Reset Link
                  </Button>
                </div>
              </Fragment>
            )}
        </Col>
      </Row>
    </Container>
  );
};

export default RequestLink;
